import React, { useState, useEffect, Children } from "react"

import FullBodyLoader from "./FullBodyLoader"

interface Props {
  children: React.ReactNode,
  tabs: Record<string, string>,
  tabClickCallback?: Function,
  savePreferredTabLSId?: string,
  selectedTab?: number,
  loading?: boolean
}

const Tabs = (props: Props) => {
  // State
  const [currentTab, setCurrentTab] = useState(0)
  const [tabNames, setTabKeys] = useState<string[]>(Object.keys(props.tabs))

  // DidMount
  useEffect(() => {
    const newTabNames = Object.keys(props.tabs)

    setTabKeys(newTabNames)

    if (props.savePreferredTabLSId) {
      const savedIndex = localStorage.getItem(`tabs__${props.savePreferredTabLSId}`)
      if (savedIndex) {
        setCurrentTab(parseInt(savedIndex))
      }
    }
  }, [props.children, props.tabs])

  // Change the tab number using props
  useEffect(() => {
    if (props.selectedTab !== undefined && props.selectedTab >= 0 && props.selectedTab < tabNames.length && props.selectedTab !== currentTab) {
      setCurrentTab(props.selectedTab)
    }
  }, [props.selectedTab])

  const setTab = (index: number, name: string) => {
    setCurrentTab(index)

    if (props.savePreferredTabLSId) {
      localStorage.setItem(`tabs__${props.savePreferredTabLSId}`, index.toString())
    }

    if (props.tabClickCallback) {
      props.tabClickCallback(name)
    }
  }

  return (
    <div className={`tabs ${props.loading && "relative"}`}>
      <div className="tabs__tab-buttons">
        {tabNames.map((name, index) => {
          return (
            <div
              className={`tabs__tab-buttons__button ${index === currentTab ? "active" : ""}`}
              key={name}
              onClick={() => setTab(index, name)}
            >
              {props.tabs[name]}
            </div>
          )
        })}
      </div>
      {Children.toArray(props.children)[currentTab]}

      <FullBodyLoader loading={props.loading || false} />
    </div>
  )
}

export default Tabs
